import HttpRequest from '@/util/axios.config';

const setLang = () => {
    HttpRequest.post('v3/web/common/manage/setLanguage', {}, [() => false, false]);
};

export default setLang;